import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI} from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';

export const tagslice = createSlice({
    name: 'tag',
    initialState: {
        data: [],
        meta: [],
        loading: false,
        hasErrors: false,
        notification: { show: false, messageContent: "", messageType: "success" }
    },
    reducers: {
        getTagData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        getTagDataSuccess: (state, action) => {
            return {
                ...state,
                data: action && action.payload && action.payload.data && action.payload.data.data,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "success" },
                hasErrors: false,
                loading: false
            }
        },
        getTagDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "error" }
            }
        },
        postTagData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        postTagDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "success" }
            }
        },
        postTagDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "error" }
            }
        },
        putTagData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        putTagDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.message], messageType: "success" }
            }
        },
        putTagDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "error" }
            }
        },
        deleteTagData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        deleteTagDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "success" }
            }
        },
        deleteTagDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                notification: { show: true, messageContent: [action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.message], messageType: "error" }
            }
        },

        resetTag: (state) => {
            return {
                ...state,
                loading: false,
                hasError: false,
                notification: { show: false, messageContent: "", messageType: "success" }
            }
        },


    }
})
export const { getTagData, getTagDataSuccess, getTagDataFailure, postTagData, postTagDataSuccess, postTagDataFailure,
    putTagData, putTagDataSuccess, putTagDataFailure,
    deleteTagData, deleteTagDataSuccess, deleteTagDataFailure,resetTag } = tagslice.actions;


export const fetchTagData = () => dispatch => {
    dispatch(getTagData());
    try {
        LABELGENAPI
            .get("/settings/tag")
            .then(function (response) {
                dispatch(getTagDataSuccess(response));
            })
            .catch(function (error) {
                dispatch(getTagDataFailure(error.response));
            });
    } catch (error) {
        dispatch(getTagDataFailure());
    }
};

export const storeTagData = (userid,data) => dispatch => {
    dispatch(postTagData());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.post('/settings/tag', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(postTagDataSuccess(response));
                dispatch(fetchTagData());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'TAG_CREATE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(postTagDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'TAG_CREATE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(postTagDataFailure(error.response));
    }
}
export const updateTagData = (userid,id, data) => dispatch => {
    dispatch(putTagData());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.patch('/settings/tag/' + id, data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(putTagDataSuccess(response));
                dispatch(fetchTagData());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'TAG_UPDATE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(putTagDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'TAG_UPDATE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(putTagDataFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'TAG_UPDATE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}
export const destoryTagData = (userid,id) => dispatch => {
    dispatch(deleteTagData());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI
            .delete("/settings/tag/" + id, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(deleteTagDataSuccess(response));
                dispatch(fetchTagData());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'TAG_DELETE',
                    action: 'SUCCESS',
                    request_data: JSON.stringify(id),
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            })
            .catch(function (error) {
                dispatch(deleteTagDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'TAG_DELETE',
                    action: 'FAILURE',
                    request_data: JSON.stringify(id),
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            });
    } catch (error) {
        dispatch(deleteTagDataFailure(error));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'TAG_DELETE',
            action: 'FAILURE',
            request_data: JSON.stringify(id),
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
};
export const resetTagState = data => dispatch => {
    dispatch(resetTag());
}




export default tagslice.reducer;
